import { useSearchParams } from "react-router-dom";
import CrmPanel from "@/components/crm/CrmPanel";
import PageHeader from "@/app/PageHeader";
import { useSession } from "@/app/session";

const AdminCrm = () => {
  const { token, onAuthError } = useSession();
  // ?lead=<id> (from the pipeline board or workspace search) opens that lead.
  const [params] = useSearchParams();

  return (
    <div data-testid="crm-page">
      <PageHeader title="Leads"
        intro="Find businesses to pitch, pull in their emails and phone numbers, and work each lead from first call to install." />
      <CrmPanel token={token} onAuthError={onAuthError} initialLeadId={params.get("lead")} />
    </div>
  );
};

export default AdminCrm;
